// extracted by mini-css-extract-plugin
export var MoreServices = "style-module--MoreServices--0b45a";
export var MoreServicesLink = "style-module--MoreServicesLink--8f4a5";
export var Services = "style-module--Services--3063a";
export var SlideContServicesainer = "style-module--SlideContServicesainer--09ecf";